import { render, staticRenderFns } from "./Attr.vue?vue&type=template&id=73007653&scoped=true&"
import script from "./Attr.vue?vue&type=script&lang=js&"
export * from "./Attr.vue?vue&type=script&lang=js&"
import style0 from "./Attr.vue?vue&type=style&index=0&id=73007653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73007653",
  null
  
)

export default component.exports